export default class User {
    #id
    #name;
    #lastName;
    #role;
    #permissions;
    #email;
    #createDate;
    #avatar;
    #color;
    #token;
    #isLogged;

  constructor(id = 0, name = null, lastName = null, role = 'guest', permissions = [], email = null,
    createDate = null, avatar = '.images/pages/user.png', color = null, token = null, isLogged = false) {
    this.#id = id;
    this.#name = name;
    this.#lastName = lastName;
    this.#role = role;
    // Store permission names only for easier checks
    this.#permissions = permissions.map(p =>
      typeof p === 'string' ? p : p.name
    );
    this.#email = email;
    this.#createDate = new Date(createDate);
    this.#avatar = avatar;
    this.#color = color;
    this.#token = token;
    this.#isLogged = isLogged;
  }

  
    get id() {
        return this.#id;
    }

    get name() {
        return this.#name;
    }

    get lastName() {
        return this.#lastName;
    }

    get permissions() {
        return this.#permissions;
    }

    get role() {
        return this.#role;
    }

    get email() {
        return this.#email;
    }

    get createDate() {
        return this.#createDate;
    }

    get avatar() {
        return this.#avatar;
    }

    get color() {
        return this.#color;
    }

    set color(value) {
        this.#color = value;
    }

    set avatar(value) {
        this.#avatar = value;
    }

    get isLogged() {
        return this.#isLogged;
    }

    get token() {
        return this.#token;
    }

    set token(token) {
        this.#token = token;
    }

    set isLogged(isLogged) {
        this.#isLogged = isLogged;
    }


    hasRole(role) {
        return this.#role === role;
    }

    hasPermission(permission) {
        if (!Array.isArray(this.#permissions) || this.#permissions.length === 0) {
            return false;
        }
        return this.#permissions.includes(permission);
    }

    canEditArticle(id){
        if(this.hasPermission('article.edit')){
            return true;
        }else if(this.hasPermission('article.ownerEdit')){
            return this.#id === id;
        }else{
            return false;
        }
    }

    canDeleteArticle(id){
        if(this.hasPermission('article.delete')){
            return true;
        }else if(this.hasPermission('article.ownerDelete')){
            return this.#id === id;
        }else{
            return false;
        }
    }
    
    //Implementar aqui los metodos para modificar los atributos en el backend
    set permissions(permissions) {
        //
    }

    set name(name) {
        //
    }

    set role(role) {
        //
    }

    set email(email) {
        //
    }

    addPermission(permission) {
        //
    }

    removePermission(permission) {
       //
    }

}